import {
  ApiError,
  InfrastructureService,
  OpenAPI,
  type SaveDocumentCommand
} from './generated';

export { ApiError };

let antiforgeryToken: string | null = null;
let applicationVersionObserver: ((version: string) => void) | null = null;
let fetchObserverInstalled = false;

const applicationVersionHeaderName = 'X-Backend-Version';

OpenAPI.BASE = '';
OpenAPI.WITH_CREDENTIALS = true;
OpenAPI.CREDENTIALS = 'same-origin';
OpenAPI.HEADERS = async (options): Promise<Record<string, string>> => {
  if (options.url === '/api/antiforgery-token') {
    return {};
  }

  return { 'X-CSRF-TOKEN': await loadAntiforgeryToken() };
};

export function initializeApplicationVersionObserver(observer: (version: string) => void): void {
  applicationVersionObserver = observer;
  if (fetchObserverInstalled) {
    return;
  }

  const browserFetch = globalThis.fetch.bind(globalThis);
  globalThis.fetch = async (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
    const response = await browserFetch(input, init);
    const version = response.headers.get(applicationVersionHeaderName);
    if (version != null && version.length > 0) {
      try {
        applicationVersionObserver?.(version);
      } catch (error) {
        console.error('Unable to process the application version response header.', error);
      }
    }

    return response;
  };
  fetchObserverInstalled = true;
}

export async function loadAntiforgeryToken(): Promise<string> {
  if (antiforgeryToken) {
    return antiforgeryToken;
  }

  const payload = await InfrastructureService.getAntiforgeryToken();
  if (!payload.requestToken) {
    throw new Error('Antiforgery token response was empty.');
  }

  antiforgeryToken = payload.requestToken;
  return antiforgeryToken;
}

export function clearAntiforgeryToken(): void {
  antiforgeryToken = null;
}

export function setAntiforgeryToken(token: string): void {
  antiforgeryToken = token;
}

export async function logout(): Promise<void> {
  await InfrastructureService.logout();
  clearAntiforgeryToken();
}

export async function saveDocumentWithKeepalive(request: SaveDocumentCommand): Promise<void> {
  const token = await loadAntiforgeryToken();
  await fetch('/api/commands/SaveDocumentCommand', {
    body: JSON.stringify(request),
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-TOKEN': token
    },
    keepalive: true,
    method: 'POST'
  });
}
